import React from 'react';

function ItemModal({ show, onClose, onSubmit, form, handleChange, naturezas = [], tiposBens = [], title = 'CADASTRO DE ITEM' }) {
  if (!show) return null;
  const tiposFiltrados = tiposBens.filter(t => t.idNatureza === form.idNatureza);
  return (
    <div className="modal show d-block" tabIndex="-1"
      style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1055, position: 'fixed', inset: 0 }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header bg-success text-white" style={{ padding: '0.35rem 1rem' }}>
            <h6 className="modal-title mb-0 small"><i className="bi bi-list-ul me-2"></i>{title}</h6>
            <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <form onSubmit={onSubmit}>
              <div className="mb-3">
                <label className="form-label">Natureza *</label>
                <select className="form-select form-select-sm" name="idNatureza" value={form.idNatureza} onChange={handleChange} required>
                  <option value="">Selecione...</option>
                  {naturezas.map(n => (
                    <option key={n.id} value={n.id}>{n.descricao}</option>
                  ))}
                </select>
              </div>
              <div className="mb-3">
                <label className="form-label">Tipo de Bem *</label>
                <select className="form-select form-select-sm" name="idTipoBem" value={form.idTipoBem} onChange={handleChange} required>
                  <option value="">Selecione...</option>
                  {tiposFiltrados.map(t => (
                    <option key={`${t.idNatureza}_${t.id}`} value={t.id}>{t.descricao}</option>
                  ))}
                </select>
              </div>
              <div className="mb-3">
                <label className="form-label">Código *</label>
                <input type="number" className="form-control form-control-sm" name="id" value={form.id} onChange={handleChange} required />
              </div>
              <div className="mb-3">
                <label className="form-label">Descrição *</label>
                <textarea className="form-control form-control-sm" name="descricao" value={form.descricao} onChange={handleChange} rows={3} required />
              </div>
              <div className="d-flex justify-content-end gap-2">
                <button type="button" className="btn btn-secondary btn-sm" onClick={onClose}>Cancelar</button>
                <button type="submit" className="btn btn-success btn-sm">Salvar</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ItemModal;
